<template>
    <div>
    <section class="section img-bg" id="happy-people-bg">
      <br><br><br>
      <div class="container">
        <h2 class="title is-1 has-text-centered" id="blue-title">We work for you, the seller</h2>
        <div class="columns has-text-white">
          <div class="column"></div>
          <div class="column is-half">
            <h3 class="subtitle is-3 has-text-centered has-text-white">Sell Faster At The Best Price</h3>
              <br class="is-hidden-mobile">
            <p class="is-1 has-text-weight-semibold">With NestEgg you get:</p>
            <ul class="ul-ticks">
              <li>certainty of your property value</li>
              <li>access to buyers through the best agents in your area</li>
              <li>experts representing YOU for the best sale outcome</li>
            </ul>
            <br><br>
            <p class="title is-4 has-text-weight-semibold has-text-white">{{ contactMeCta }}</p>
            <p class="has-text-centered" id="small-reminder" v-if="addressTouched">*If you live in a flat, just enter your street address without the unit number</p>
            <div class="gmap-holder">
              <GmapInput
                  class="input is-rounded"
                  id="suburbInput"
                  placeholder="Enter your street address"
                  :componentRestrictions="{country: 'ZA'}"
                  @place_changed="setPlace"
                  @input="addressTouched = true"
              ></GmapInput>
              <router-link class="button is-primary" to="/contact-me">Sell Now</router-link>
            </div>
            <br>
          </div>
          <div class="column"></div>
        </div>

      </div>
      <div class="is-hidden-mobile"><br><br><br><br><br></div>
    </section>

    <!--SA Covid-19 Gov Portal Link-->
      <div class="" style="width:100%;background: #132533; font-size: 15px; text-align: center; color: white; padding: 8px 15px;">For <b>COVID-19</b> updates, visit official government website <a href="https://sacoronavirus.co.za/" target="_blank" style="color: white; text-decoration: underline;" rel="nofollow">www.sacoronavirus.co.za</a></div>
    <!--SA Covid-19 Gov Portal Link End-->

    <section class="section has-text-centered">
      <div class="container">
        <h2 class="title">How we help you</h2>
        <h3 class="subtitle is-5 has-text-weight-normal">We do real estate differently</h3>
        <br><br>

        <div class="columns is-variable is-3">
          <div class="column">
            <img alt="Bank Valuation" class="benefit-icon" src="../assets/images/home/benefit_01.svg">
            <p>Our experienced agents will value your property to help you price right</p>
          </div>
          <div class="column">
            <img alt="Buyer Viewings" class="benefit-icon" src="../assets/images/home/benefit_03.svg">
            <p>We collaborate with the best agents in your area to access their buyers</p>
          </div>
          <div class="column">
            <img alt="Negotiate Offers" class="benefit-icon" src="../assets/images/home/benefit_04.svg">
            <p>We help you negotiate offers to get you the best deal</p>
          </div>
          <div class="column">
            <img alt="Legal Services" class="benefit-icon" src="../assets/images/home/benefit_05.svg">
            <p>We provide free legal & contractual services to protect your interests</p>
          </div>
        </div>

        <br>
        <router-link class="button is-black" to="/sell-with-us#why-we-are-different">Why we are different</router-link>
      </div>
    </section>

    <section class="section has-background-light-blue">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column">
            <h2 class="title">What you pay</h2>
            <ul class="ul-bullets">
              <li>We negotiate the best commission on your behalf</li>
              <li>You only pay when you sell</li>
              <li>NestEgg fees are covered by the buyer's agent - so no extra cost to you</li>
            </ul>
          </div>

          <div class="column">
            <img alt="NestEgg Commision" src="../assets/images/home/pricing.svg">
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column">
            <img alt="We Keep it Simple" class="smaller" src="../assets/images/home/feature.svg">
          </div>

          <div class="column">
            <h2 class="simple-title title">We keep it simple</h2>
            <div class="simple-row is-flex">
              <div class="circled-number">1</div>
              <span>You sign our simple listing agreement</span>
            </div>
            <div class="simple-row is-flex">
              <div class="circled-number">2</div>
              <p>We partner with the top agents to access the best buyers</p>
            </div>
            <div class="simple-row is-flex">
              <div class="circled-number">3</div>
              <p>Our simple Sale Agreement and Legal Support protect you</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-text-centered img-bg" id="house-bg">
      <div class="container">
        <h2 class="title has-text-white">Happy customers!</h2>
        <carousel
          :autoplay="true"
          :autoplayHoverPause="false"
          :autoplayTimeout="9000"
          :loop="true" 
          :perPage="1"
          class="has-text-centered"
        >
          <slide>
            <h3 class="title is-4 has-text-green">Brenda - Northdene</h3>
            <h4 class="is-6 has-text-white">"NestEgg treats sellers and buyers as dignified human beings. It's not about commission but satisfying the seller/buyer. NestEgg is 1 in a million. Happiness!"</h4>
            <br>
            <p class="green-stars">★★★★★</p>
          </slide>

          <slide>
            <h3 class="title is-4 has-text-green">Modisaemang - Langa</h3>
            <h4 class="is-6 has-text-white">"Hi Helen and team,<br>I just want to send my sincere gratitude for your help, professionalism, and above all smooth process in selling my house. This was my first ever property sale transaction, and it all went well. My old perception of estate agents has been proven wrong."</h4>
            <br>
            <p class="green-stars">★★★★★</p>
          </slide>

          <slide>
            <h3 class="title is-4 has-text-green">Iqbal - Kloof</h3>
            <h4 class="is-6 has-text-white">"Hi Helen,<br>Thank you so much.<br>It really has been a pleasure dealing with Rima and yourself.<br>Always willing to assist and make sure your clients are happy.<br>Thank you"</h4>
            <br>
            <p class="green-stars">★★★★★</p>
          </slide>
        </carousel>
      </div>
      <br>
    </section>

    <section class="section has-text-centered">
      <div class="container">
        <h2 class="title">Ready to sell or want to find out more?</h2>
        <p>One of our expert agents will call you back to discuss your needs</p>
        <br>
        <router-link class="button is-primary" to="/contact-me">Contact Me</router-link>
      </div>
    </section>
    </div>
</template>

<script>
    import GmapInput from 'vue2-google-maps/src/components/autocomplete.vue'
    import { Carousel, Slide } from 'vue-carousel'

    export default {
        components: {
          Carousel,
          GmapInput,
          Slide
        },
        data() {
          return {
            addressSet: false,
            contactMeCta: 'F',
            contactMeCtaFull: 'ind out how to get SOLD with NestEgg! 🏡',
            addressTouched: false
          }
        },
        methods: {
          setPlace(place) {
              this.addressSet = true;
              this.$parent.address = place;
          }
        },
        mounted() {
          var i = 0,
              scope = this;
          var timer = setInterval(function(){
            scope.contactMeCta += scope.contactMeCtaFull[i];
            i++;
            if (i >= scope.contactMeCtaFull.length) {
              clearInterval(timer)
            }
          }, 50);
        }
    }
</script>

<style lang="scss">
  @import '../assets/sass/colours.scss';

  .VueCarousel-navigation-button {
    font-size: 4.5em;
    outline: none !important;
  }

  .VueCarousel-dot-container {
    margin: unset !important;
  }

  .VueCarousel-dot--active {
    color: $blue;
    background-color: $blue !important;
  }

  @media screen and (min-width: 769px) {
    .VueCarousel-slide h4 {
      padding-left: 22rem;
      padding-right: 22rem;
    }

    .img-bg {
      background-size: cover;
    }
  }

  @media screen and (max-width: 768px) {
    .VueCarousel-navigation-button {
      display: none;
    }

    #happy-people-bg {
      background-position: 40% 10%;
    }

  }

  .green-stars {
      color: $green;
      font-weight: bold;
  }

  .benefit-icon {
    width: 5rem;
  }

  .gmap-holder {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #suburbInput {
    margin-right: 10px;
  }

  .column img:not(.benefit-icon):not(.is-rounded):not(.footer-icon):not(.unpadded) {
    padding: 1rem 2rem;
  }

  .circled-number {
    background-color: $primary;
  }

  .smaller {
    height: 50vmin;
    max-height: 400px;
  }

  .brand-logo {
    width: 100%;
    padding: 0 !important;
  }

  #blue-title {
    color: $blue;
  }

  .img-bg {
    background-repeat: no-repeat;
  }

  #happy-people-bg {
    background-image: url("../../public/img/banner_img_bg.jpg");
  }

  #house-bg {
    background-image: url("../../public/img/customer_review_bg.jpg");
    background-size: cover;
  }

  #small-reminder {
    font-size: 0.9em;
    margin-top: -1em;
    margin-bottom: 0.5em;
  }
</style>